/**
 * @deprecated DO NOT USE THIS TYPE. Prefer FeatureFlagsKeys and FeatureFlagsValues instead.
 * Feature flags are used to enable/disable features in the app
 */
export interface FeatureFlags {
  feature_permissions: FeaturePermissions;
  unifiedProgressCheckSurvey: boolean;
}

export enum FeatureFlagsKeys {
  MFA_PROFESSIONAL = "mfa_professional",
  HYBRID_CARE_AI_ENABLED = "hybrid_care_ai_enabled",
  COMPANION_PAGE = "companion_page_enabled_web",
  COMPANION_MODEL_VERSION = "companion_model_version",
  ENABLE_OLI_V2 = "enable_oli_v2",
  BL0CK_OLI_FROM_WEB = "block_oli_from_web",
  OLI_STREAMING_MODE = "oli_streaming_mode",
  NEW_OLI_AGENT_ENABLED = "new_oli_agent_enabled",
  ONLY_SLACK_MANAGERS_SECTION_WEB = "only_slack_managers_section_web",
  ENABLE_INSIGHTS_CTAS_SLACK = "enable_insights_ctas_slack",
  DISABLE_ONBOARDING_QUESTIONS = "disable_onboarding_questions",
  ENABLE_INDIVIDUAL_CONTRIBUTOR_VIEW = "enable_individual_contributor_view",
  DIGEST_BASED_INSIGHTS_ENABLED = "digest_based_insights_enabled",
  GOOGLE_DRIVE_INTEGRATION = "google_drive_integration",
  ONLY_REPORT_RELATIONSHIP_TYPE = "only_report_relationship_type",
  SEND_NUDGES = "send_nudges",
  NUDGES_ORG_OBJECTIVES_ONLY = "nudges_org_objectives_only",
  DISABLE_USER_MANUAL = "disable_user_manual",
  ENABLE_PERSONAL_GOALS = "enable_personal_goals",
  ENABLE_MULTI_ATTENDEE_MEETINGS = "enable_multi_attendee_meetings",
  SEND_WEEKLY_REFLECTIONS = "send_weekly_reflections",
  NUDGE_EMAIL_EXTRA_RECIPIENTS = "nudge_email_extra_recipients",
}

export interface FeatureFlagsValues {
  [FeatureFlagsKeys.MFA_PROFESSIONAL]: boolean;
  [FeatureFlagsKeys.HYBRID_CARE_AI_ENABLED]: boolean;
  [FeatureFlagsKeys.COMPANION_PAGE]: boolean;
  [FeatureFlagsKeys.COMPANION_MODEL_VERSION]: number;
  [FeatureFlagsKeys.ENABLE_OLI_V2]: boolean;
  [FeatureFlagsKeys.BL0CK_OLI_FROM_WEB]: boolean;
  [FeatureFlagsKeys.OLI_STREAMING_MODE]: boolean;
  [FeatureFlagsKeys.NEW_OLI_AGENT_ENABLED]: boolean;
  [FeatureFlagsKeys.ONLY_SLACK_MANAGERS_SECTION_WEB]: boolean;
  [FeatureFlagsKeys.ENABLE_INSIGHTS_CTAS_SLACK]: boolean;
  [FeatureFlagsKeys.DISABLE_ONBOARDING_QUESTIONS]: boolean;
  [FeatureFlagsKeys.ENABLE_INDIVIDUAL_CONTRIBUTOR_VIEW]: boolean;
  [FeatureFlagsKeys.DIGEST_BASED_INSIGHTS_ENABLED]: boolean;
  [FeatureFlagsKeys.GOOGLE_DRIVE_INTEGRATION]: boolean;
  [FeatureFlagsKeys.ONLY_REPORT_RELATIONSHIP_TYPE]: boolean;
  [FeatureFlagsKeys.SEND_NUDGES]: boolean;
  [FeatureFlagsKeys.NUDGES_ORG_OBJECTIVES_ONLY]: boolean;
  [FeatureFlagsKeys.DISABLE_USER_MANUAL]: boolean;
  [FeatureFlagsKeys.ENABLE_PERSONAL_GOALS]: boolean;
  [FeatureFlagsKeys.ENABLE_MULTI_ATTENDEE_MEETINGS]: boolean;
  [FeatureFlagsKeys.SEND_WEEKLY_REFLECTIONS]: boolean;
  [FeatureFlagsKeys.NUDGE_EMAIL_EXTRA_RECIPIENTS]: string[];
}

/**
 * Feature permissions are used to enable/disable features for specific users
 */
export interface FeaturePermissions {
  chat_as_care_navigator: Array<string>;
  chat_as_clinical_supervisor: Array<string>;
  chat_as_oliva_customer_support: Array<string>;
  admin_tools: Array<string>;
}
